import { Alert, Card as AntdCard, Col, Pagination, Row, message } from 'antd'
import React, { useEffect, useMemo, useState } from 'react'
import { Card } from '../../../../../components'
import { api } from '../../../../../services'
import TrainingListActions from '../components/TrainingListActions'
import TrainingListContainer from '../components/TrainingListContainer'
import { types } from '../types'
import TrainingSequence from '../components/TrainningSquence'
import { Container, Draggable } from 'react-smooth-dnd'
import { useTranslation } from 'react-i18next'

const PAGE_LIMIT = 12

function PodcastList(props) {
  const [podcastsList, setPodcasts] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [search, setSearch] = useState('')
  const [pageOffset, setPageOffset] = useState(0)
  const [total, setTotal] = useState(0)
  const [sequenceState, setSequenceState] = useState(false)
  const [isInitialLoad, setIsInitialLoad] = useState(true)
  const [seqList, setSeqList] = useState([])
  const [newSequence, setNewSequence] = useState([])

  useEffect(() => {
    const fetchMazeData = () => {
      if (!loading) setLoading(true)
      api.events
        .get({
          mode: 'all',
          schedule_state: 'all',
          event_type: 'discussion_room',
          offset: pageOffset,
          limit: PAGE_LIMIT,
          search
        })
        .then(res => {
          setPodcasts(res.data.data)
          if (isInitialLoad) {
            setSeqList(res.data.data.slice(0, 10))
            setIsInitialLoad(false)
          }
          setTotal(parseInt(res.data.pagination.total))
          setLoading(false)
          setError(false)
        })
        .catch(err => {
          setTotal(0)
          setPodcasts([])
          setLoading(false)
          setError(true)
        })
    }
    fetchMazeData()
  }, [pageOffset, search])

  const handlePagination = pageNumber =>
    setPageOffset(pageNumber * PAGE_LIMIT - PAGE_LIMIT)

  const handleSearch = searchValue => {
    setPageOffset(0)
    setSearch(searchValue)
  }
  const onCardClick = ({ id }) => props.history.push(`/podcast/${id}/play`)

  const currentPageNumber = useMemo(() => pageOffset / 10 + 1, [pageOffset])

  const showItems = !loading && podcastsList.length > 0
  const handleSaveSequence = () => {
    api.events
      .setSequence({
        mode: 'all',
        schedule_state: 'all',
        event_type: 'discussion_room',
        offset: pageOffset,
        limit: PAGE_LIMIT,
        search
      })
      .then(res => {
        setPodcasts(res.data.data)
        if (isInitialLoad) {
          setSeqList(res.data.data.slice(0, 10))
          setIsInitialLoad(false)
        }
        setTotal(parseInt(res.data.pagination.total))
        setLoading(false)
        setSequenceState(false)
        setError(false)
      })
      .catch(err => {
        setTotal(0)
        setPodcasts([])
        setLoading(false)
        setSequenceState(false)
        setError(true)
      })
  }
  const { t } = useTranslation()
  return (
    <TrainingListContainer title={t('v3:podcast')}>
      <TrainingListActions
        type={types.PODCAST}
        loading={loading}
        onListSearch={handleSearch}
        sequenceState={sequenceState}
        handleSaveSequence={handleSaveSequence}
        openSequenceState={val => {
          setSequenceState(val)
        }}
      />
      <Row gutter={[8, 8]}>
        <Col xs={24} sm={24} md={sequenceState ? 16 : 24}>
          {showItems && (
            <div className="training-list-pagination">
              <h2>
                {search && (
                  <>
                    {t('v4:search_result')}
                    <u>{search}</u> -
                  </>
                )}{' '}
                {podcastsList.length}{' '}
                {podcastsList.length <= 1 ? t('v2:item') : t('v3:items')}
              </h2>
            </div>
          )}
          {loading ? (
            <div className="training-list-cards">
              {Array.from(Array(PAGE_LIMIT).keys()).map(item => (
                <AntdCard style={{ width: 250 }} loading>
                  {t('v4:this_card')}
                </AntdCard>
              ))}
            </div>
          ) : error ? (
            <Alert type="error" message="Error !" />
          ) : podcastsList.length === 0 ? (
            <Alert
              message={
                search
                  ? `${t('v4:search_for')} '${search}' ${t(
                      'v4:search_no_result'
                    )}`
                  : t('v5:no_podcast_is_available')
              }
            />
          ) : (
            <div className="training-list-cards">
              {podcastsList.map((item, index) => (
                <Container
                  key={index}
                  groupName="1"
                  behaviour="copy"
                  getChildPayload={() => item}
                >
                  <Draggable payload={item}>
                    <Card
                      type={types.PODCAST}
                      mode="all"
                      data={{ ...item, type: 'Live Event' }}
                      onClick={onCardClick}
                      tagName="live_event"
                    />
                  </Draggable>
                </Container>
              ))}
            </div>
          )}
          <div className="pagination-wrapper">
            {showItems && (
              <Pagination
                disabled={loading}
                total={total}
                pageSize={PAGE_LIMIT}
                onChange={handlePagination}
                defaultCurrent={currentPageNumber}
              />
            )}
          </div>
        </Col>
        {sequenceState && (
          <Col xs={24} sm={24} md={8}>
            <TrainingSequence
              seqList={seqList}
              setNewSequence={setNewSequence}
              loading={loading}
              type={types.PODCAST}
            />
          </Col>
        )}
      </Row>
    </TrainingListContainer>
  )
}

export default PodcastList
